import axios from "@/lib/axios";
import { useMutation } from "@tanstack/vue-query";
import { Cef } from "../interfaces/cef";

interface CefEdit {
  cefId: string | number;
  name: string;
}

const cefEdit = async (params: CefEdit) => {
  const { data } = await axios.put<Cef>(`/api/cefs/${params.cefId}`, {
    name: params.name,
  });

  return data;
};

const useEditCef = () => {
  const mutationCef = useMutation((params: CefEdit) => {
    return cefEdit(params);
  });

  return {
    mutationCef,
    mutationCefLoading: mutationCef.isLoading,
    mutationCefError: mutationCef.isError,
    mutationCefSuccess: mutationCef.isSuccess,
    mutationCefAsync: mutationCef.mutateAsync,
  };
};

export default useEditCef;
